module.exports = __webpack_public_path__ + "static/media/tou.f39092ef.png";